import Vue from 'vue'
import App from './app.vue'
import vuetify from '@/plugins/vuetify'
import store from '@/store'
import arrayHelpers from '@/plugins/array-helpers'
import router from '@/router'
import VueGtag from "vue-gtag";

Vue.config.productionTip = false

Vue.use(arrayHelpers)

Vue.use(VueGtag, { config: { id: "G-Q1LP2NSSQ9" } }, router);

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
